"use strict"

const ClusterWS = require('clusterws-client-js');
import {PromiseIO} from './promiseIO';

export function ServiceIOWS(options) {
    
    const socket = new ClusterWS(Object.assign({
        url: 'ws://' + window.location.hostname + ':' + window.location.port,
        autoReconnect: true
    }, options || {}));
        
    

    const EventEmitter = require('./eventEmitter');
    const wsEvents = new EventEmitter();
    const wsSubscribers = new EventEmitter();
    
    function randomID() {
        return Math.random().toString(36).substr(2, 9);
    }
    
    function emit(event, args, emitter) {
        args = Array.prototype.slice.call(args);
        args.unshift(event),
        emitter.emit.apply(emitter, args);
    }
    
    socket._on = socket.on;
    
    socket.on = function (event, fn, ctx) {
        wsEvents.on(event, fn, ctx);
        if (!socket.events.events[event]) {
            socket._on(event, function () {
                emit(event, arguments, wsEvents);
            })
        }
    }

    socket._off = socket.off;    

    socket.off = function (event, fn, ctx) {
        wsEvents.removeListener(event, fn, ctx);

        if (wsEvents.listenerCount(event) == 0) {
            // console.log('REMOVE EVENT ' + event);
            socket._off(event);
        }
    }

    // console.log(socket);
    
    const _requests = {};
    const _channels = {};

    // console.log(socket);

    socket._subscribe = socket.subscribe;
    socket.subscribe = function (event, fn, ctx) {
        wsSubscribers.on(event, fn, ctx);
        if (socket.getState() == 1) {
            _channels[event] = socket._subscribe(event).watch(function () {
                emit(event, arguments, wsSubscribers);
            });
        }
    }

    socket.on('connect', function () {
        wsSubscribers.eventNames().forEach(event => {
            _channels[event] = socket._subscribe(event).watch(function () {
                emit(event, arguments, wsSubscribers);
            });
        });        
    })

    socket.unsubscribe = function (event, fn, ctx) {
        wsSubscribers.off(event, fn, ctx);

        // console.log('unsubscribe', wsSubscribers.listenerCount(event));
        if (wsSubscribers.listenerCount(event) == 0) {
            // console.log('UNSUBSCRIBE ' + event);

            _channels[event].unsubscribe();
            delete _channels[event];
        }
    }



    socket.call = function (path, query = {}) {
        
        return new PromiseIO((resolve, reject, triger, promise) => {

            const rid = randomID();
        
            _requests[rid] = promise;
        
            (function doSend() {
                try {
                    if (socket.getState() == 1) {
                        socket.send('rpc', {
                            rid: rid,
                            path: path,
                            query: query
                        });
                    } else {
                        setTimeout(doSend, 500);
                    }
                } catch (e) {
                    setTimeout(doSend, 500);
                }    
            })();

        });
    }
    
    socket.on('rpc', (message) => {
        const promise = _requests[message.rid];
        if (promise) {
            promise.resolve(message.payload);
            delete _requests[message.rid];
        }
    })
    
    socket.on('event', (message) => {
        const promise = _requests[message.rid];
        if (promise) {
            promise.trigger(message.payload);
        }
    })
    
    /*
    socket.call = function (path, data, callbacks) {
        const rid = randomID();
    
        if (typeof callbacks == 'function')
            callbacks = {
                result: callbacks
            }
    
        if (!callbacks.event)
            callbacks.event = function () {}
    
        _requests[rid] = callbacks;
    
        (function doSend() {
            try {
                if (socket.getState() == 1) {
                    socket.send('rpc', {
                        rid: rid,
                        path: path,
                        data: data
                    });
                } else {
                    setTimeout(doSend, 500);
                }
            } catch (e) {
                setTimeout(doSend, 500);
            }    
        })();
    }
    
    socket.on('rpc', (data) => {
        const cb = _requests[data.rid];
        if (cb) {
            if (data.e)
                data.e = new Error(data.e);

            cb.result(data.e, data.data);
            delete _requests[data.rid];
        }
    })
    
    socket.on('event', (data) => {
        const cb = _requests[data.rid];
        if (cb) {
            cb.event(data.data);
        }
    }) */

    // if (options.debug) {

    //     var refresh = false;
    
    //     socket.on('connect', function () {
    
    //         if (refresh)
    //             return location.reload();
    
    //         socket.subscribe('debug').watch((message) => {
    //             if (message.cmd == 'refresh') {
    //                 setTimeout(location.reload.bind(location), 300);                    
    //             }
    //         })
    //     })
    
    //     socket.on('disconnect', function () {
    //         refresh = true;
    //     })
    // }

    return socket;
}

// global.ServiceIO = ServiceIO;

// module.exports.ServiceIO = ServiceIO;